(function () {
  console.log(
    "product-form-preset-product-combination 模板正确, 这是当前的产品",
    location.href
  );

  /**
   * @等待直到指定类名的元素存在
   * @param {string} className - 目标元素的类名
   * @param {function} callback - 元素存在时执行的回调函数
   */
  const waitForElement = (selectorClass, attrName, callback) => {
    if (!selectorClass) {
      return console.error("waitForElement >>>>>>>> 未传入类名");
    }

    const observer = new MutationObserver(() => {
      const targetElement = document.querySelector(selectorClass);

      if (attrName) {
        if (targetElement && targetElement[attrName]) {
          observer.disconnect(); // 停止观察

          callback(targetElement); // 执行 回调函数
        }
      } else {
        if (targetElement) {
          observer.disconnect(); // 停止观察

          callback(targetElement); // 执行回调函数
        }
      }
    });

    // 开始观察文档主体以检测DOM变化
    observer.observe(document.body, {
      childList: true, // 观察子节点变化
      subtree: true, // 观察所有后代节点
    });
  };

  /**
   * @处理选中事件
   */
  function handelSelected(targetEle) {
    // 如果没有传入 targetEle，则默认处理第一个 .block-swatch__item

    if (!targetEle) {
      // 遍历所有的 .block-swatch__radio，找到 checked 为 true 的 input
      $(".block-swatch-list .block-swatch__radio").each(function () {
        if (this.checked) {
          targetEle = $(this).next(".block-swatch__item"); // 选取相邻的元素
          return false; // 终止循环
        }
      });

      if (!targetEle || !targetEle.length) return; // 没有选中的元素则返回
    } else {
      targetEle = $(targetEle); // 确保 targetEle 是 jQuery 对象
    }

    // 找到当前 label 对应的 .product-form-combine-product-container
    const $contentContainer = targetEle.find(
      ".product-form-combine-product-container"
    );

    if (!$contentContainer.length) return; // 容错处理

    const $content = $contentContainer.find(".product-form-combine-product");

    if (!$content.length) return; // 容错处理

    // 获取实际高度
    const contentHeight = $content.prop("scrollHeight") + "px";

    // **立即展开当前选中的元素**
    $contentContainer.css({
      height: contentHeight,
      opacity: "1",
    });

    // **延迟 500ms 后收起其他元素（避免影响当前展开）**
    $(".product-form-combine-product-container")
      .not($contentContainer) // 过滤掉当前展开的元素
      .css({
        height: "0px",
        opacity: "0",
      });
  }

  /**
   * 监听选项点击事件
   */
  const parentElement = document.querySelector(".product-form__variants"); // 替换为实际的父元素选择器

  parentElement.addEventListener("click", (event) => {
    const target = event.target;

    if (
      target.tagName === "LABEL" &&
      target.classList.contains("block-swatch__item")
    ) {
      handelSelected(target);
    }
  });

  /**
   * @初始化
   */
  // 等待 dom 节点里面是否有一个属性
  waitForElement(
    ".product-form .product-form__variants .block-swatch__item .product-form-combine-product-container .product-form-combine-product",
    null,
    (targetEle) => {
      handelSelected();
    }
  );
})();
